import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import '@mantine/notifications/styles.css'
import { createBrowserRouter } from 'react-router'
import routes from './routes'
import { setupStore } from './redux/store'

const router = createBrowserRouter(routes)
const root = createRoot(document.getElementById('root'))

const store = setupStore()

root.render(<App store={store} router={router}/>)
